/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const GATEWAY_PREFIX = 'GATEWAY_';

export const FETCH_GATEWAY_CAMPING_SEARCH_START = `${GATEWAY_PREFIX}FETCH_CAMPING_SEARCH_START`;
export const FETCH_GATEWAY_CAMPING_SEARCH_SUCCESS = `${GATEWAY_PREFIX}FETCH_CAMPING_SEARCH_SUCCESS`;
export const FETCH_GATEWAY_CAMPING_SEARCH_FAILURE = `${GATEWAY_PREFIX}FETCH_CAMPING_SEARCH_FAILURE`;

export const FETCH_GATEWAY_TICKET_SEARCH_START = `${GATEWAY_PREFIX}FETCH_TICKET_SEARCH_START`;
export const FETCH_GATEWAY_TICKET_SEARCH_SUCCESS = `${GATEWAY_PREFIX}FETCH_TICKET_SEARCH_SUCCESS`;
export const FETCH_GATEWAY_TICKET_SEARCH_FAILURE = `${GATEWAY_PREFIX}FETCH_TICKET_SEARCH_FAILURE`;

export const FETCH_GATEWAY_POI_SEARCH_START = `${GATEWAY_PREFIX}FETCH_POI_SEARCH_START`;
export const FETCH_GATEWAY_POI_SEARCH_SUCCESS = `${GATEWAY_PREFIX}FETCH_POI_SEARCH_SUCCESS`;
export const FETCH_GATEWAY_POI_SEARCH_FAILURE = `${GATEWAY_PREFIX}FETCH_POI_SEARCH_FAILURE`;

export const FETCH_GATEWAY_SEARCH_START = `${GATEWAY_PREFIX}FETCH_SEARCH_START`;
export const FETCH_GATEWAY_SEARCH_SUCCESS = `${GATEWAY_PREFIX}FETCH_SEARCH_SUCCESS`;
export const FETCH_GATEWAY_SEARCH_FAILURE = `${GATEWAY_PREFIX}FETCH_SEARCH_FAILURE`;

export const FETCH_GATEWAY_ACTIVITY_PASSES_SEARCH_START = `${GATEWAY_PREFIX}FETCH_GATEWAY_ACTIVITY_PASSES_SEARCH_START`;
export const FETCH_GATEWAY_ACTIVITY_PASSES_SEARCH_SUCCESS = `${GATEWAY_PREFIX}FETCH_GATEWAY_ACTIVITY_PASSES_SEARCH_SUCCESS`;
export const FETCH_GATEWAY_ACTIVITY_PASSES_SEARCH_FAILURE = `${GATEWAY_PREFIX}FETCH_GATEWAY_ACTIVITY_PASSES_SEARCH_FAILURE`;

export const FETCH_GATEWAY_TREE_PERMITS_SEARCH_START = `${GATEWAY_PREFIX}FETCH_GATEWAY_TREE_PERMITS_SEARCH_START`;
export const FETCH_GATEWAY_TREE_PERMITS_SEARCH_SUCCESS = `${GATEWAY_PREFIX}FETCH_GATEWAY_TREE_PERMITS_SEARCH_SUCCESS`;
export const FETCH_GATEWAY_TREE_PERMITS_SEARCH_FAILURE = `${GATEWAY_PREFIX}FETCH_GATEWAY_TREE_PERMITS_SEARCH_FAILURE`;

export const FETCH_GATEWAY_VENUE_RESERVATIONS_SEARCH_START = `${GATEWAY_PREFIX}FETCH_GATEWAY_VENUE_RESERVATIONS_SEARCH_START`;
export const FETCH_GATEWAY_VENUE_RESERVATIONS_SEARCH_SUCCESS = `${GATEWAY_PREFIX}FETCH_GATEWAY_VENUE_RESERVATIONS_SEARCH_SUCCESS`;
export const FETCH_GATEWAY_VENUE_RESERVATIONS_SEARCH_FAILURE = `${GATEWAY_PREFIX}FETCH_GATEWAY_VENUE_RESERVATIONS_SEARCH_FAILURE`;

export const FETCH_GATEWAY_VENUE_FACILITIES_SEARCH_START = `${GATEWAY_PREFIX}FETCH_GATEWAY_VENUE_FACILITIES_SEARCH_START`;
export const FETCH_GATEWAY_VENUE_FACILITIES_SEARCH_SUCCESS = `${GATEWAY_PREFIX}FETCH_GATEWAY_VENUE_FACILITIES_SEARCH_SUCCESS`;
export const FETCH_GATEWAY_VENUE_FACILITIES_SEARCH_FAILURE = `${GATEWAY_PREFIX}FETCH_GATEWAY_VENUE_FACILITIES_SEARCH_FAILURE`;
